import _Input from './Input';

import './style/index.js';

export type { InputProps } from './Input';
export * from './type';

export const Input = _Input;
export default Input;
